import React from 'react';

const SectionHeader = ({ badge, title, subtitle, align = 'center' }) => (
  <div className={`lp-section-header lp-section-header--${align}`}>
    {badge ? <span className="lp-badge">{badge}</span> : null}
    <h2 className="lp-section-title">{title}</h2>
    {subtitle ? <p className="lp-section-subtitle">{subtitle}</p> : null}
  </div>
);

export default SectionHeader;
